export default __webpack_public_path__ + "static/media/015-warning-2.8ca74498.png";